import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class AksharApiKeys extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };
        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
        //for update dialog component ok click
        this.Okbutton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.FetchDataAjax()
                this.dialogClose();
                this.setState({
                    isChecked: true

                })
            }
        }];
        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.FetchDataAjax()
                this.dialogClose();
                this.setState({
                    isChecked: true,
                    disabled: false
                })
            }
        }];
        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAksharDataApi(this.state.propsId)
                this.setState({
                    disabled: false, isChecked: true, showTable: true
                })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    isChecked: true,
                    disabled: false,
                    showTable: true

                });
            }
        }];
        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.FetchDataAjax()
                this.setState({ isChecked: true, disabled: false, showTable: true })

            }
        }];
        this.state = {
            data: [{
                id: '',
                apiType: '',
                key: '',
                secret: '',
                label: '',
                enabled: ''
            }],
            editedapiType: '-1',
            pageNum: null,
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            contentEditable: "false",
            showStore: false,
            hideDeletePopup: false,
            deleteRow: false,
            isChecked: false,
            showTable: false,
            deactivateCheck: false
        }
        this.editImageSrc = "./assets/images/edit2.png";
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.apitypeVar = [];
    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchAksharDataApi();
        }, 300);
        var thisController = this;
        document.addEventListener("projectChanged", function (event) {
            thisController.state.disabled = false;
            thisController.projectId = event.projectId;
            thisController.fetchAksharDataApi(event.projectId);
            thisController.fetchToggleDataApi(event.projectId);

        });
    }
    addAksharData = (data) => {
        var thisController = this;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            apiType: ''
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    notifyEmptyField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });

    }
    notifyDataAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key Added Successfully</b>, {
            position: "top-center",

        });
    }
    notifyDataUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;API key updated Successfully</b>, {
            position: "top-center",

        });
    }

    addAksharDataApi = (props) => {
        var thisController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            thisController.notifyEmptyField();
        } else {
            $.ajax({
                url: "/api/api-key",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "AKSHAR_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyDataAdded();
                        thisController.fetchAksharDataApi();
                        thisController.state.disabled = false;
                    } else {
                        thisController.notifyFailedToAddData(res.result);
                        thisController.state.disabled = false;
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }
    updateAksharDataApi = (props) => {
        var thisController = this;
        props.original.label = document.getElementById("label" + props.index).innerText.trim();
        props.original.enabled = document.getElementById("enableApiKey" + props.index).checked;
        if (props.original.label == "") {
            thisController.notifyEmptyField();
        } else {
            $.ajax({
                url: "/api/api-key-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: {
                    id: props.original.id,
                    projectId: localStorage.getItem("currentProjectId"),
                    apiType: "AKSHAR_API",
                    label: props.original.label,
                    enabled: props.original.enabled
                },

                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyDataUpdate();
                        thisController.fetchAksharDataApi();
                        thisController.state.editedapiType = '-1';
                        thisController.state.disabled = false;
                    } else {
                        thisController.notifyFailedToAddData(res.result);
                        thisController.state.disabled = false;
                        thisController.state.editedapiType = '-1';
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }

            });
        }
    }

    notifyFailedToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyFailedToAddData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;Please fill label field</b>, {
            position: "top-center"
        });
    }
    notifyFailedToLoadData(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
        this.fetchAksharDataApi();
    }

    activateApiKeyApi = () => {
        var thisContoller = this;

        $.ajax({
            url: "/api/akshar-enable",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisContoller.setState({
                        isChecked: true, showTable: true
                    })
                    thisContoller.fetchToggleDataApi();
                    thisContoller.NotifyActivated();

                } else {
                    thisContoller.notifyFailedToActivate();
                }
            },
            error: function (xhr, status, error) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }


    deactivateAPIKeyApi = () => {
        var thisContoller = this;

        $.ajax({
            url: "/api/akshar-disable",
            async: false,
            method: 'POST',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    thisContoller.setState({
                        isChecked: false, showTable: false
                    })
                    thisContoller.state.disabled = true;
                    thisContoller.fetchToggleDataApi();
                    thisContoller.notifyDeActivated();

                } else {
                    thisContoller.notifyFailedToActivate();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });

    }
    notifyDeActivated() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;API key de-activated successfully</b>, {
            position: "top-center"
        });
    }
    NotifyActivated() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;API key activated successfully</b>, {
            position: "top-center"
        });
    }

    notifyFailedToActivate() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Failed to activate API key</b>, {
            position: "top-center"
        });
    }
    fetchToggleDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        $.ajax({
            url: "/api/akshar-status",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.result === true) {
                    thisController.setState({
                        isChecked: true,
                        showTable: true
                    })
                }
                else if (res.result === false) {
                    thisController.setState({
                        isChecked: false,
                        showTable: false
                    })
                }

            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    fetchAksharDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var thisController = this;
        var apis = [];
        $.ajax({
            url: "/api/api-key/api-type",
            async: false,
            method: 'GET',
            data: {
                projectId: projectId,
                apiType: "AKSHAR_API"
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
                "Content-Type": "application/json",
            },

            success: function (res) {
                if (res.success === true) {
                    var apiData = res.result;
                    for (var i = 0; i < apiData.length; i++) {
                        if (apiData[i].apiType == "AKSHAR_API") {
                            apis.push(apiData[i]);
                        }
                        thisController.fetchToggleDataApi();
                    }
                    thisController.setState({
                        data: apiData,
                        disabled: false,
                    })
                }
                else {
                    thisController.notifyFailedToLoadData(res.result)
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deleteAksharDataApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteRowViewController.splice(id, 1);
            deleteApiViewController.fetchAksharDataApi();
            deleteApiViewController.notifyDeleted();
            deleteApiViewController.state.disabled = false;
        }
        $.ajax({
            url: "/api/api-key/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteApiViewController.fetchAksharDataApi();
                    deleteApiViewController.notifyDeleted();
                    deleteApiViewController.state.disabled = false;

                } else {
                    deleteApiViewController.notifyFailedToDelete(res.result);
                    deleteApiViewController.state.disabled = false;
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });

    }
    notifyDeleted() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;API key Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    notifyAutoGenerate = () => {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;API key and secret will be generate automatically</b>, {
            position: "top-center"
        });
    }
    notifyFailedToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelledit(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {

        this.state.editedapiType = id;
        var stateObj = this.state;
        this.setState(stateObj);

    }
    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedapiType = id;
        this.fetchAksharDataApi()
        this.setState({ disabled: false })

    }
    checkActivationHandle = () => {
        if (document.getElementById("activate").checked == true) {
            this.activateAPIKeyaHandleChange();
        } else {
            this.deactivateAPIKeyaHandleChange();
        }

    }
    activateAPIKeyaHandleChange = (e) => {

        this.setState({

            isChecked: true,
            showTable: true

        })

        this.activateApiKeyApi();
    }

    deactivateAPIKeyaHandleChange = (e) => {

        this.setState({

            isChecked: false,
            showTable: false

        })
        this.deactivateAPIKeyApi();

    }
    render() {
        this.columns = [
            {
                Header: 'Id',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Label</b>,
                accessor: 'label',
                sortable: false,
                Cell: props => (<div className="input"
                    Align="left"
                    style={{ width: '98%', padding: '8px', border: (props.original.id == undefined || props.original.id == this.state.editedapiType) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px' }}
                    contentEditable={!((props.original.id == undefined) ? false :
                        props.original.id != this.state.editedapiType) ? "plaintext-only" : false}
                    type="text" id={"label" + props.index}>{props.original.label}</div>
                )
            },
            {
                Header: <b>Key</b>,
                accessor: 'key',
                sortable: false,
                Cell: props => (<div onClick={(e) => { ((props.original.id == undefined) || props.original.id == this.state.editedapiType) ? this.notifyAutoGenerate() : "" }}
                    Align="left" className="textarea"
                    contentEditable={false}
                    type="text" id={"key" + props.index}>{props.original.key}</div>
                )
            },
            {
                Header: <b>Secret</b>,
                accessor: 'secret',
                sortable: false,
                Cell: props => (<div onClick={(e) => { ((props.original.id == undefined) || props.original.id == this.state.editedapiType) ? this.notifyAutoGenerate() : "" }}
                    Align="left" className="textarea"
                    contentEditable={false}
                    type="text" id={"secret" + props.index}
                >{props.original.secret}</div>)
            },
            {
                Header: <b>Enable API Key</b>,
                accessor: 'enableApiKey',
                sortable: false,
                width: 110,
                Cell: props => {
                    return (
                        <div style={{ textAlign: 'center' }}>
                            <label class="switch">
                                <input type="checkbox" id={"enableApiKey" + props.index}
                                    defaultChecked={props.original.enabled}
                                    disabled={(props.original.id == undefined) ? false : props.original.id != this.state.editedapiType} />
                                <span class="slider round"></span>
                            </label>
                        </div>
                    )
                }
            },

            {
                Header: <b>Action</b>,
                accessor: 'action',
                sortable: false,
                width: 100,
                Cell: props => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedapiType) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.original.id == undefined) ? this.saveImageSrc : ((props.original.id != this.state.editedapiType) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == undefined) ? this.addAksharDataApi(props, e) : (props.original.id == this.state.editedapiType) ?
                                        this.updateAksharDataApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>
                        <button style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            marginTop: '-9px', marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchAksharDataApi() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original.id
                                    })
                                } />
                        </button>
                    </div>
                ),
            },
        ]
        return (
            <div style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                {/* for reactTable */}

                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />

                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />

                <div className="wrapper">
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | API keys </title>
                    {/* IonIcons */}
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                    <div className="container-fluid" >
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h1 className="m-0 page-title">Transliteration API Settings</h1>
                                    <h6 className="taglineTxt">Agent Configurations</h6>

                                </div>

                            </div>
                        </div>
                        <div className="row" style={{ marginLeft: '8px', marginTop: '10px' }}>
                            <label>Transliteration API </label>
                            <label class="switch" style={{ marginLeft: '15px' }}>

                                <input type="checkbox"
                                    id={"activate"}
                                    onChange={this.checkActivationHandle}

                                    checked={this.state.isChecked}
                                />
                                <span class="slider round"></span>
                            </label>

                        </div>
                        < ToastContainer className="Toast-at-center" />
                        <div className="row" style={{ display: (this.state.isChecked) ? 'block' : 'none' }}>
                            <div className="col-sm-5">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '20px' }}>Basic settings</h6>
                            </div>
                            <div className="col-sm-7" Align="right">
                                <button className="btn action-button"
                                    title="Add"
                                    id="addApiType"
                                    onClick={this.state.disabled ? this.notifyEmptyFields : this.addAksharData}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} type="button" title="Refresh" className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img></button>
                            </div>
                            <div className="col-lg-12 ">

                                <div className="card">

                                    <div >
                                        <ReactTable id='reactTable'
                                            data={this.state.data}
                                            columns={this.columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                        {/*Dialog Component For Deletion Confirmation*/}
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Akshar API Key' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the API key?<br />
                                            &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default AksharApiKeys




// WEBPACK FOOTER //
// ./src/aksharUi/AksharApiKeys.js